import React from "react";
import { useNavigate } from "react-router-dom";
import RecipeEditor from "../components/RecipeEditor";
import { useUser } from "../contexts/UserContext";

const AddRecipe = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  const initialRecipe = {
    title: "",
    description: "",
    cookTime: "",
    source: "",
    course: "",
    cuisine: "",
    serves: "",
    equipment: [],
    images: [],
    videoUrl: "",
    instructions: [
      {
        "text": "",
        "imageUrl": ""
      }
    ],
    ingredients: [
      {
        section: null,
        items: [
          {
            name: "",
            quantity: "",
            units: ""
          }
        ]
      }
    ],
    tags: [],
    created: "",
    updated: "",
    userId: user.id,
    userDisplayName: user.name
  };

  const handleSaveComplete = () => {
    navigate("/");
  };

  return (
    <RecipeEditor
      initialRecipe={initialRecipe}
      onSaveComplete={handleSaveComplete}
      pageTitle="Add Recipe"
    />
  );
};

export default AddRecipe;
